<template>
  <div class="inquiryItinerary">
    <div class="container">
      <div>
        <Title />
        <div class="row justify-content-between">
          <Breadcrumb />
        </div>
      </div>
      <div class="card mb-3 table-top-bar">
        <div class="card-body p-0">
          <div class="input-group">
            <span class="input-group-text d-none d-sm-block">
              顯示第
              {{ currentPage == 1 ? 1 : perPage * (currentPage - 1) + 1 }} 至
              {{
                currentPage == 1
                  ? totalRows > perPage
                    ? perPage
                    : totalRows
                  : perPage * (currentPage - 1) + perPage > totalRows
                  ? totalRows
                  : perPage * (currentPage - 1) + perPage
              }}
              項結果，共 {{ totalRows }} 項
            </span>
            <input
              v-model="filter"
              type="text"
              class="form-control"
              placeholder="搜尋"
            />
            <span class="input-group-text"><i class="bi bi-search"></i></span>
          </div>
        </div>
      </div>
      <div class="card mb-3">
        <div class="card-body">
          <b-table
            :responsive="windowWidth > breakpoints.sm"
            :stacked="windowWidth <= breakpoints.sm"
            striped
            borderless
            no-provider-filtering
            head-variant="light"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template v-slot:head()="scope">
              <div class="text-nowrap">
                {{ scope.label }}
              </div>
            </template>
            <template v-slot:cell(itinerary)="data">
              {{ data.item.itinerary.name }}
            </template>
            <template v-slot:cell(status)="data">
              <span :class="data.item.status ? 'text-info' : 'text-danger'">{{
                data.item.status ? '已處理' : '未處理'
              }}</span>
            </template>
            <template v-slot:cell(active)="data">
              <div class="d-flex">
                <button
                  @click="showModal(data.item.id)"
                  type="button"
                  class="btn btn-link px-1"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="編輯"
                >
                  <i class="bi bi-pencil mx-1 fs-5"></i>
                </button>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="d-block d-sm-none text-center mb-3">
        顯示第 {{ currentPage == 1 ? 1 : perPage * (currentPage - 1) + 1 }} 至
        {{
          currentPage == 1
            ? totalRows > perPage
              ? perPage
              : totalRows
            : perPage * (currentPage - 1) + perPage > totalRows
            ? totalRows
            : perPage * (currentPage - 1) + perPage
        }}
        項結果，共 {{ totalRows }} 項
      </div>
      <b-pagination
        v-if="totalRows > perPage"
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        align="right"
        first-number
        last-number
        class="mb-sm-0 mb-3 mt-sm-0 mt-3"
      ></b-pagination>
    </div>
    <div
      class="modal fade"
      id="itineraryModal"
      tabindex="-1"
      ref="itineraryModal"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content" v-if="modalDate">
          <div class="modal-header">
            <h5 class="modal-title">旅遊行程諮詢單</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="row mb-3">
              <div class="col-md-3 text-gray">諮詢單號</div>
              <div class="col-md-9">
                {{ modalDate.serial_no }}
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-3 text-gray">行程</div>
              <div class="col-md-9">
                {{ modalDate.itinerary.name }}
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-3 text-gray">客戶姓名</div>
              <div class="col-md-9">
                {{ modalDate.name }}
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-3 text-gray">連絡電話</div>
              <div class="col-md-9">
                {{ modalDate.phone }}
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-3 text-gray">連絡信箱</div>
              <div class="col-md-9">
                {{ modalDate.email }}
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-3 text-gray">詳細需求</div>
              <div class="col-md-9">
                {{ modalDate.content }}
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <div>
              <select class="form-select" v-model="modalDate.status">
                <option value="0">未處理</option>
                <option value="1">已處理</option>
              </select>
            </div>
            <button
              type="button"
              class="btn btn-secondary ms-auto"
              data-bs-dismiss="modal"
            >
              取消
            </button>
            <button @click="save" type="button" class="btn btn-primary">
              儲存
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { inquiry } from '@/http/api/inquiry.js'
import { mapState, mapMutations, mapGetters } from 'vuex'
import { Modal } from 'bootstrap'
import Title from '@/components/layout/Title.vue'
import Breadcrumb from '@/components/layout/Breadcrumb.vue'

export default {
  name: 'InquiryProduct',
  components: { Title, Breadcrumb },
  data () {
    return {
      bootstrap_modal: null,
      currentPage: 1,
      form: null,
      filter: null,
      filterOn: ['serial_no', 'name', 'itinerary', 'phone', 'email'],
      fields: [
        {
          key: 'serial_no',
          label: '諮詢單號',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'itinerary',
          label: '行程',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'name',
          label: '姓名',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'phone',
          label: '電話',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'email',
          label: '信箱',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'status',
          label: '狀態',
          class: 'align-middle',
          sortable: true
        },
        {
          key: 'active',
          label: '功能',
          class: 'align-middle'
        }
      ],
      items: null,
      modalID: null,
      modalDate: null
    }
  },
  computed: {
    ...mapState([
      'token',
      'windowWidth',
      'breakpoints',
      'perPage',
      'totalRows'
    ]),
    ...mapGetters(['errMsgInfo'])
  },
  watch: {
    'token.headers.Authorization': function (data) {
      if (data) {
        this.getData()
      }
    },
    currentPage () {
      this.$nextTick(() => this.InitBootstrapTooltip())
    },
    items () {
      this.$nextTick(() => this.InitBootstrapTooltip())
    }
  },
  methods: {
    ...mapMutations([
      'Loading',
      'Loaded',
      'AlertsInfo',
      'Alerted',
      'SetRouterName',
      'InitBootstrapTooltip',
      'SetTotalRows',
      'SetErrMsg'
    ]),
    getData () {
      const vm = this
      vm.Loading()
      inquiry
        .getItinerary('', vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.items = data.data.sort((a, b) =>
              Date.parse(a.created_at).valueOf() >
              Date.parse(b.created_at).valueOf()
                ? -1
                : 1
            )
            vm.SetTotalRows(vm.items.length)
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    onFiltered (filteredItems) {
      const vm = this
      vm.SetTotalRows(filteredItems.length)
      vm.currentPage = 1
    },
    showModal (id) {
      const vm = this
      vm.modalID = id
      vm.Loading()
      vm.bootstrap_modal = new Modal(vm.$refs.itineraryModal)
      inquiry
        .getItinerary(id, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.modalDate = data.data
            vm.bootstrap_modal.show()
            vm.Loaded()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
            vm.Alerted()
          }
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    },
    save () {
      const vm = this
      vm.Loading()
      inquiry
        .updateItinerary(vm.modalID, { status: vm.modalDate.status }, vm.token)
        .then((res) => {
          const { data } = res
          if (res.status <= 201 && data.status === 'success') {
            vm.AlertsInfo({
              state: 'success',
              title: '成功',
              info: '更新資料成功'
            })
            vm.bootstrap_modal.hide()
            vm.getData()
          } else {
            vm.SetErrMsg(data.errMsg)
            vm.AlertsInfo({
              state: 'error',
              title: '失敗 ' + res.status,
              info: vm.errMsgInfo
            })
          }
          vm.Alerted()
          vm.Loaded()
        })
        .catch((err) => {
          vm.SetErrMsg(err)
          vm.AlertsInfo({
            state: 'error',
            title: '失敗',
            info: vm.errMsgInfo
          })
          vm.Alerted()
          vm.Loaded()
        })
    }
  },
  created () {
    const vm = this
    vm.SetRouterName(vm.$route.name)
  },
  mounted () {
    const vm = this
    if (vm.token.headers.Authorization) {
      vm.getData()
    }
  }
}
</script>
